// test994
(994 && 0);
